// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper__hs3CA"};